import { removePersistentItem as r, setPersistentItem as s, getPersistentItem as i } from "./utils/storage.js";
const t = {
  get: i,
  set: s,
  remove: r
};
function n(e) {
  e && e.get && (t.get = e.get), e && e.set && (t.set = e.set);
}
export {
  n as overridePersistentStorage,
  t as persistentStorage
};
//# sourceMappingURL=storage.js.map
